import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

// Flecha flotante "volver arriba": aparece al bajar y sube al pulsar.
export function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Volver arriba"
      data-testid="scroll-top-button"
      className="anim-fab-in fixed right-4 md:right-6 bottom-24 md:bottom-24 z-40 grid place-items-center h-12 w-12 rounded-full bg-[#2A00D9] text-white shadow-lg shadow-[#2A00D9]/30 border border-white/20 hover:bg-[#B4D844] hover:text-[#1A1A1A] transition-colors"
    >
      <ArrowUp size={22} strokeWidth={2.5} />
    </button>
  );
}
